import { Link } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';
import FaqAccordion from '@/components/feature/FaqAccordion';
import { faqs } from '@/mocks/gossip';

export default function HomeFaqSection() {
  return (
    <section id="faq" className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-50">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
        <div>
          <SectionHeading
            eyebrow="常见问题"
            title="参与之前，先把规则看明白"
            desc="关于转发抽奖、评论区打卡和粉丝投票的常见疑问，都整理在这里。"
          />
          <Link
            to="/faq"
            className="mt-6 inline-flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 whitespace-nowrap"
          >
            查看全部问题
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="lg:col-span-2">
          <FaqAccordion items={faqs.slice(0, 4)} />
        </div>
      </div>

      <div className="mt-14 rounded-lg bg-foreground-900 px-6 py-10 md:px-12 md:py-14 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div>
          <h3 className="font-heading text-2xl md:text-3xl text-background-50">
            今天的福利还在等你
          </h3>
          <p className="mt-2 text-sm md:text-base text-background-50/75 max-w-xl">
            打卡累计、转发参与、投票选出你心中的名场面，三种玩法随时可以开始。
          </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-3 shrink-0">
          <Link
            to="/activities"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors"
          >
            <i className="ri-gift-line"></i>
            立即参与互动
          </Link>
          <Link
            to="/topics"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-background-50/40 text-background-50 text-sm whitespace-nowrap hover:bg-background-50/10 transition-colors"
          >
            先逛逛热榜
          </Link>
        </div>
      </div>
    </section>
  );
}